import ApolloClient, { InMemoryCache } from "apollo-boost";
// import { getInstance } from "@/auth";

export default new ApolloClient({
  uri: process.env.VUE_APP_GRAPH,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  request: async operation => {
    // const authService = getInstance();
    // if (authService.isAuthenticated) {
    // const token = await authService.getTokenSilently();
    operation.setContext({
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        // Authorization: token ? `Bearer ${token}` : "",
      },
    });
    // }
  },
});
